import { render, staticRenderFns } from "./SplitRecordManage.vue?vue&type=template&id=235c752c&scoped=true"
import script from "./SplitRecordManage.vue?vue&type=script&lang=js"
export * from "./SplitRecordManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRecordManage.vue?vue&type=style&index=0&id=235c752c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c752c",
  null
  
)

export default component.exports